import cs from "clsx"
import styles from "./Header.module.css"
import { Logout } from "./logout"
import { HeaderTitle } from "./header-title"
import { useStoreShared } from "../../../../store"
import {  QuestionMarkCircleOutline } from "heroicons-react";
import { useState } from "react";
import { InfoModal } from "./Information-modal";
interface Props {
  className: string
  title?: string
}

export function Header({ className, title }: Props) {
  const { stateShared } = useStoreShared()
  const isTelekom = sessionStorage.getItem("currentClientUuid") === "39d60ce7-6e1a-4cab-87ed-047e6323e262";
  const [showModal, setShowModal] = useState(false)
  return (
    <header className={cs(styles.root, className)}>
      <Logout></Logout>

      {title && <HeaderTitle title={title}></HeaderTitle>}
      {!title && <HeaderTitle title={stateShared.currentClient?.name}></HeaderTitle>}
      {isTelekom &&  <QuestionMarkCircleOutline className={styles.info} onClick={() => setShowModal(true)}></QuestionMarkCircleOutline>}
      {showModal && <InfoModal showModal={showModal}   hideModal={() => setShowModal(false)}></InfoModal>}
    </header>
  )
}
